import { Check } from "lucide-react";

export const PLAN_ORDER = ["free", "professional", "business", "enterprise"];

function PlanCard({ id, plan, cycle, isCurrent, featured, onSelect, ctaLabel }) {
  const price = cycle === "yearly" ? plan.yearly : plan.monthly;
  const cta = isCurrent ? "Current plan" : id === "free" ? "Get started" : ctaLabel;
  const btnClass = isCurrent
    ? "bg-slate-100 text-slate-400 cursor-default"
    : featured
    ? "bg-[#2563EB] text-white hover:bg-[#1D4ED8]"
    : "bg-[#0A0F1C] text-white hover:bg-[#1E293B]";

  return (
    <div
      data-testid={`plan-card-${id}`}
      className={`relative rounded-xl border bg-white p-6 flex flex-col transition-all duration-200 hover:-translate-y-1 hover:shadow-md ${
        featured ? "border-[#2563EB] shadow-md ring-1 ring-[#2563EB]/20" : "border-slate-200"
      }`}
    >
      {featured && (
        <span className="absolute -top-3 left-6 bg-[#2563EB] text-white text-[11px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full">
          Most popular
        </span>
      )}
      <h3 className="font-heading text-lg font-bold text-[#0A0F1C]">{plan.display_name || plan.name}</h3>
      {plan.display_name && plan.display_name !== plan.name && (
        <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400 mt-0.5">{plan.name} plan</span>
      )}
      <div className="mt-3 flex items-end gap-1">
        <span className="font-mono text-3xl font-bold text-[#0A0F1C]">${price}</span>
        <span className="text-slate-400 text-sm mb-1">/{cycle === "yearly" ? "yr" : "mo"}</span>
      </div>
      {cycle === "yearly" && price > 0 && (
        <p className="text-xs text-[#65A30D] font-medium mt-1">~17% savings vs monthly</p>
      )}
      <ul className="mt-5 space-y-2.5 flex-1">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm text-slate-600">
            <Check size={16} className="text-[#16A34A] mt-0.5 shrink-0" />
            {f}
          </li>
        ))}
      </ul>
      <button
        disabled={isCurrent}
        onClick={() => onSelect?.(id)}
        data-testid={`plan-select-${id}`}
        className={`mt-6 h-11 rounded-md font-medium transition-colors ${btnClass}`}
      >
        {cta}
      </button>
    </div>
  );
}

export default function PricingTable({ plans, cycle, currentPlan, onSelect, ctaLabel = "Choose plan" }) {
  if (!plans) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
      {PLAN_ORDER.map((id) => {
        const plan = plans[id];
        if (!plan) return null;
        return (
          <PlanCard
            key={id}
            id={id}
            plan={plan}
            cycle={cycle}
            isCurrent={currentPlan === id}
            featured={id === "professional"}
            onSelect={onSelect}
            ctaLabel={ctaLabel}
          />
        );
      })}
    </div>
  );
}
